export default defineAppConfig({
  // ui: {
  //   colors: {
  //     primary: 'green',
  //     neutral: 'slate'
  //   }
  // }
})
